import { useEffect } from 'react';
import { UPDATE_REQUIRED_HEADLINE, useUpdateActions } from '@hopdrive/sdk-app-updater/react';

type RequireUpdate = (request: { headline: string }) => boolean;

let current: RequireUpdate | null = null;

/**
 * The server refused this build (`CLIENT_UPDATE_REQUIRED`): hand the page to
 * the updater, which reloads now or opens "This page is out of date" over
 * unsaved work. The Apollo error link calls this, because it lives outside
 * React. False until `DealerUpdater` has mounted.
 */
export function requireDealerUpdate(): boolean {
  return current ? current({ headline: UPDATE_REQUIRED_HEADLINE }) : false;
}

/** Mounted once inside `DealerUpdater`: points `requireDealerUpdate` at the provider's action. */
export function UpdateRequiredBridge(): null {
  const { requireUpdate } = useUpdateActions();
  useEffect(() => {
    current = requireUpdate;
    return () => {
      if (current === requireUpdate) current = null;
    };
  }, [requireUpdate]);
  return null;
}
